
import { defineComponent } from "vue";
import Registration from "@/components/Admin/RegistryView/UserRegistration/UserRegistration.vue";
import UserReports from "@/components/Admin/RegistryView/UserReports/UserReports.vue";
import ManageUsers from "@/components/Admin/RegistryView/ManageUsers/ManageUsers.vue";

export default defineComponent({
  name: "RegistryView",
  components: {
    Registration,
    UserReports,
    ManageUsers,
  },
  data() {
    return {
      tabs: [
        {
          tab: "Registration",
          text: "Sign Up Requests",
          icon: "bi-hourglass",
        },
        {
          tab: "Members",
          text: "Manage Users",
          icon: "bi-clipboard-check",
        },
        {
          tab: "Reports",
          text: "Reports",
          icon: "bi-slash-circle",
        },
      ],
      activeTab: "Registration",
      show: true,
    };
  },
  methods: {
    switchTab(tab: string) {
      this.activeTab = tab;
    },
    toggleSidebar() {
      this.show = !this.show;
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.show = window.innerWidth > 768;
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", () => {
      this.show = window.innerWidth > 768;
    });
  },
});
